module.exports = __webpack_public_path__ + "resources/img/img_watchall_nms1_m.7edd1259f10f72b677e0f5bbe4018a1f.png";